<template>
    <div>
        <div class="title">
            <div class="title-img" v-if="img1">
                <img :src="img1" alt srcset1 class="title-img-img"/>
            </div>
            <div class="title-context">
                <div class="title-context1">{{form.name}}</div>
                <div class="title-context2">负责人：{{form.charge}}</div>
                <div class="title-context3">电话：{{form.phone}}</div>
                <div class="title-context4">地址：{{form.address}}</div>
            </div>
        </div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="margin-top:30px">
            <el-tab-pane label="基本信息" name="first">
                <el-form v-if="activeName=='first'" ref="form" :model="form" label-width="140px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="机构名称">
                                <el-input v-model="form.name"></el-input>
                            </el-form-item>
                            <el-form-item label="机构类型" prop="type">
                                <el-select v-model="form.type" style="width:100%">
                                    <el-option label="机构养老" value="0"></el-option>
                                    <el-option label="社区养老" value="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="房产所有权属">
                                <el-select v-model="form.house" style="width:100%">
                                    <el-option label="私有" :value="0"></el-option>
                                    <el-option label="公有" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="房屋性质">
                                <el-select v-model="form.houseNature" style="width:100%">
                                    <el-option label="自建" :value="0"></el-option>
                                    <el-option label="租赁" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="性质" prop="nature">
                                <el-select v-model="form.nature" style="width:100%">
                                    <el-option label="公建公营" :value="1"></el-option>
                                    <el-option label="社会办" :value="2"></el-option>
                                    <el-option label="公建民营" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="土地性质" prop="land">
                                <el-select v-model="form.land" style="width:100%">
                                    <el-option label="划拨" :value="1"></el-option>
                                    <el-option label="有偿出让" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="建设年份" prop="years">
                                <el-date-picker
                                        v-model="form.years"
                                        type="date"
                                        placeholder="选择日期"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="建筑面积" prop="area">
                                <el-input v-model="form.area"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="机构介绍" prop="introduce">
                        <el-input v-model="form.introduce"></el-input>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="工作人员" name="second">
                <el-row v-if="activeName=='second'">
                    <el-col :span="24">
                        <h2 style="padding-left: 30px;">员工总数:{{form1.count||0}}人</h2>
                    </el-col>
                </el-row>
                <el-row v-if="activeName=='second'">
                    <el-col :span="24">
                        <div id="myChart"></div>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="床位信息" name="third">
                <el-row v-if="activeName=='third'">
                    <el-col :span="24">
                        <div id="chart" ref="chart1" style="width:300px;height:300px"></div>
                    </el-col>
                </el-row>
                <!--                <el-row>-->
                <!--                    <el-col :span="8" class="third-center">-->
                <!--                            <span-->
                <!--                        class="top1-circle-right-item-circle"-->
                <!--                        style="background:rgb(58,160,255);margin-right:20px"-->
                <!--                ></span> 单人间 20-->
                <!--                    </el-col>-->
                <!--                    <el-col :span="8" class="third-center">-->
                <!--                <span-->
                <!--                        class="top1-circle-right-item-circle"-->
                <!--                        style="background:rgb(78,203,155);margin-right:20px"-->
                <!--                ></span>双人间 20-->
                <!--                    </el-col>-->
                <!--                    <el-col :span="8" class="third-center">-->
                <!--                <span-->
                <!--                        class="top1-circle-right-item-circle"-->
                <!--                        style="background:rgb(250,211,55);margin-right:20px"-->
                <!--                ></span>三人间间 20-->
                <!--                    </el-col>-->
                <!--                </el-row>-->
            </el-tab-pane>
            <el-tab-pane label="服务产品" name="fourth">
                <el-table v-if="activeName=='fourth'" :data="tableData" border style="width: 100%">
                    {{tableData}}
                    <el-table-column prop="serviceType" label="服务类型">
                        <template slot-scope="scope">
                            <div style="text-align:center;">
                                <el-tag v-if="scope.row.serviceType==0">生活照料</el-tag>
                                <el-tag v-if="scope.row.serviceType==1" type="info">医疗保健</el-tag>
                                <el-tag v-if="scope.row.serviceType==2" type="warning">家政服务</el-tag>
                                <el-tag v-if="scope.row.serviceType==3" type="success">紧急救助</el-tag>
                                <el-tag v-if="scope.row.serviceType==4" type="danger">精神慰藉</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="serviceProducts" label="服务产品"></el-table-column>
                    <el-table-column prop="cost" label="费用(元)"></el-table-column>
                    <el-table-column prop="explains" label="说明"></el-table-column>
                </el-table>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage4"
                        :page-sizes="[10, 20, 40, 100]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    // import img1 from "@/assets/images/map/1.jpg";
    import {organizationInfoCheck, organizationPeopleList, organizationServingProductList} from "../api/index";

    export default {
        components: {},
        props: {
            row: {
                type: Object,
            }
        },
        data() {
            return {
                img1:'',
                currentPage4: 1,
                activeName: "first",
                form: {},
                form1: {},
                form2: {},
                form3: {},
                tableData: [
                    {
                        date: "医疗保健",
                        name: "健康体检",
                        address: "50元/次",
                        address1: "定期组织老人全面体检，建立老人健康档案",
                    },
                    {
                        date: "医疗保健",
                        name: "晒太阳",
                        address: "120元/次",
                        address1: "每天定时帮助老人到院子里晒太阳30分钟",
                    },
                    {
                        date: "洗护",
                        name: "帮助洗澡",
                        address: "100元/次",
                        address1: "打扫卫生",
                    },
                    {
                        date: "整理",
                        name: "整理房间",
                        address: "70元/次",
                        address1: "整理房间被褥、桌椅",
                    },
                ],
                total: 0, //总数据
                pageNo: 1,
                pageSize: 10,

            };
        },
            methods: {
                //每页请求${val}条数据
                handleSizeChange(val) {
                    this.pageSize = val;
                    this.getData3({id: this.row.id})
                    this.$message({
                        message: `每页请求${val}条数据成功`,
                        type: "success"
                    });
                },
                //请求第${val}页数据
                handleCurrentChange(val) {
                    this.pageNo = val;
                    this.getData3({id: this.row.id})
                    this.$message({
                        message: `请求第${val}页数据成功`,
                        type: "success"
                    });
                },
                //切换
              async handleClick(tab, event) {
                    if (this.activeName == 'fourth') {
                        this.getData3({organId: this.row.id})
                    } else if (this.activeName == 'first') {
                        this.getData({id: this.row.id})
                    } else if (this.activeName == 'second') {
                      let arr1 = await this.getData1({organId: this.row.id})
                        this.$nextTick(()=>{
                            setTimeout(()=>{
                                this.drawLine()
                            },500)
                        })

                    } else if (this.activeName == 'third') {
                      let arr2 = await this.getData2({id: this.row.id})
                        this.$nextTick(()=>{
                            setTimeout(()=>{
                                this.draw()
                            },500)
                        })
                    }
                },
                //绘制柱状图图表
                drawLine() {
                    let that = this
                    let number = that.form1.list.filter(item => item.workType == 1).length
                    let number1 = that.form1.list.filter(item => item.workType == 2).length
                    let number2 = that.form1.list.filter(item => item.workType == 3).length
                    let number3 = that.form1.list.filter(item => item.workType == 4).length
                    // 基于准备好的dom，初始化echarts实例
                    let myChart = this.$echarts.init(document.getElementById("myChart"));
                    // 绘制图表
                    myChart.setOption({
                        title: {text: ""},
                        tooltip: {},
                        xAxis: {
                            data: ["管理人员", "护理人员", "医疗人员", "其他人员"],
                            textStyle: {
                                color: "akyblue",
                            },
                        },
                        yAxis: {
                            axisLabel: {
                                textStyle: {
                                    color: "#999",
                                },
                            },
                        },
                        series: [
                            {
                                name: "人员部门分布",
                                type: "bar",
                                data: [number, number1, number2, number3],
                                itemStyle: {
                                    normal: {
                                        color: "#4ad2ff",
                                    },
                                },
                            },
                        ],
                    });
                },

                //绘制饼状图
                draw() {

                    let that = this
                  console.log('that.form2.checks',that.form2)
                    // 基于准备好的dom，初始化echarts实例
                    let chart = this.$echarts.init(document.getElementById("chart"));
                    // 绘制图表
                    chart.setOption({
                      title: {
                        text: "",
                        subtext: "",
                        left: "center",
                      },
                      tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b} : {c} ({d}%)",
                      },
                      legend: {
                        orient: "vertical",
                        left: "left",
                        data: ["直接访问", "邮件营销", "联盟广告", "视频广告", "搜索引擎"],
                      },
                      series: [
                        {
                          name: "访问来源",
                          type: "pie",
                          radius: "55%",
                          center: ["50%", "60%"],
                          data: [
                            {
                              value: that.form2.reserveds,
                              name: "已预约",
                              itemStyle: {color: "rgb(251,212,55)"},
                            },
                            {
                              value: Number(that.form2.beds) - Number(that.form2.checks) - Number(that.form2.reserveds),
                              name: "未入住",
                              itemStyle: {color: "rgb(78,203,115)"},
                            },
                            {
                              value: that.form2.checks,
                              name: "已入住",
                              itemStyle: {color: "rgb(240,72,100)"},
                            },

                          ],
                          emphasis: {
                            itemStyle: {
                              shadowBlur: 10,
                              shadowOffsetX: 0,
                              shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                          },
                        },
                      ],
                    });
                },
                //回写拿到基本数据
                getData(e) {
                    return new Promise(resolve => {
                        organizationInfoCheck(e).then(res => {
                            resolve(res)
                        });
                    })
                },
                //回写工作人员拿到数据
                getData1(e) {
                    let params = Object.assign({}, e, {
                        pageNo: 1,
                        pageSize: 1000
                    })
                    return new Promise(resolve => {
                        organizationPeopleList(params).then((res) => {
                            resolve(res)
                        });
                    })
                },
                //回写拿到床位数据
                getData2(e) {
                    return new Promise(resolve => {
                        organizationInfoCheck(e).then(res => {
                            resolve(res)
                        });
                    })
                },
                //回写拿到服务数据
                getData3(e) {
                    let params = Object.assign({}, e, {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize
                    })
                    return new Promise(resolve => {
                        organizationServingProductList(params).then((res) => {
                            this.tableData = res.content.list
                            this.total = res.content.count;
                            resolve(res)
                        });
                    })
                },
            },
        async mounted() {
            let arr = await this.getData({id: this.row.id})
            let arr1 = await this.getData1({organId: this.row.id})
            let arr2 = await this.getData2({id: this.row.id})
            let arr3 = await this.getData3({organId: this.row.id})
            this.form = arr.content;
            if (this.form.photo) {
                let imgItem = this.form.photo.split(";");
                imgItem.pop()
                console.log('imgItem',imgItem)
                this.img1 = imgItem[0]
            }
          console.log('arr2',arr2)
            this.form1 = arr1.content;
            this.form2 = arr2.content;
            this.form3 = arr3.content;


        },
    };
</script>

<style scoped>
    #myChart {
        width: 100%;
        height: 400px;
    }

    #myChart1 {
        width: 100%;
        height: 400px;
    }

    #chart {
        width: 500px;
        height: 400px;
        margin: 0px auto;
    }

    #chart1 {
        width: 100%;
        height: 400px;
    }

    .title {
        display: flex;
    }

    .title-img-img {
        width: 100%;
        height: 100%;
    }

    .title-img {
        width: 265px;
        height: 170px;
    }

    .title-context {
        width: 70%;
        height: 170px;
        padding-left: 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .title-context1 {
        font-size: 26px;
    }

    .title-context2,
    .title-context3,
    .title-context4 {
        font-size: 16px;
    }

    .top1-circle-right-item-circle {
        width: 5px;
        height: 5px;
        display: inline-block;
    }

    .third-center {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
